























import Vue from 'vue';
import { kebabCase } from 'lodash';

export default Vue.extend({
  name: 'CommonGoto',
  inject: {
    id: {
      type: String,
      default: ''
    }
  },
  computed: {
    href() {
      const id =
        this.$attrs && (this as any).$attrs.id!
          ? this.$attrs.id
          : (this as any).id;
      return `#${kebabCase(id)}`;
    }
  },

  methods: {
    onClick(e: MouseEvent) {
      e.stopPropagation();

      this.$router.push(this.href);
    }
  }
});
